// Thousands separators without Date/locale helpers (the lint rule on agency
// date/times can't tell a number's toLocaleString from a date's).
export const formatCount = (n) => String(Math.round(n || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const formatMinutes = (minutes) => {
  if (!minutes) return 'under a minute';
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest ? `${hours} h ${rest} min` : `${hours} h`;
};
